import { useEffect, useState } from "react";

import { Document } from "@/api/rest/models/document";
import { getWarrantySelfCheck } from "@/api/rest/services/warrantyService";

import { SelfCheck, selfCheckDocuments } from "./selfCheck";

// Looks up a self check once per draft text; no draft, a failed call or nothing to try means no tip.
export const useSelfCheck = (
  householdId: number,
  accountId: number | undefined,
  description: string | undefined,
  documents: Document[],
): SelfCheck | null => {
  const [selfCheck, setSelfCheck] = useState<SelfCheck | null>(null);

  useEffect(() => {
    setSelfCheck(null);
    if (!description || !accountId) {
      return;
    }

    let isCancelled = false;
    getWarrantySelfCheck({ householdId, accountId, description }).then((result) => {
      if (isCancelled || !result.success || result.result.steps.length === 0) {
        return;
      }
      setSelfCheck({
        steps: result.result.steps,
        documents: selfCheckDocuments(result.result.documentIds, documents),
      });
    });

    return () => {
      isCancelled = true;
    };
    // documents only resolve the chips; a new household list must not trigger another model call.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [householdId, accountId, description]);

  return selfCheck;
};
